import React, { FC } from "react";
import { Col, Row, Layout } from "antd";
import styled from "styled-components";
import mailIcon from "../assets/images/mailIcon.svg";
import locationIcon from "../assets/images/locationIcon.svg";
import Footerlogo from "../assets/images/footerLogo.png";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import {
  TwitterOutlined,
  CopyrightOutlined,
  LinkedinOutlined,
  YoutubeOutlined,
  FacebookOutlined,
  InstagramOutlined,
} from "@ant-design/icons";
import LinkComponent from "../Components/LinkComponent";
import { NavLink } from "react-router-dom";
import { getUserData, userLogout } from "../utils/utilsFunctions";

const url =
  "https://3dmake.us17.list-manage.com/subscribe/post?u=503a79527863e0c17b5fead6d&id=7332cdeefd";

// const { Search } = Input;
const { Footer } = Layout;

const FooterComp = styled(Footer)`
  background: #1a1a1a;
  color: white;
  width: 100%;
  font-size: 11px;
  .mailchimp-form {
    input {
      color: #010101;
      border: 3px solid white;
    }
    button {
      color: #fff;
      background: #1890ff;
      text-transform: uppercase;
      border: 3px solid #1890ff;
    }
  }
`;
const LogoCol = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 2rem;
`;
const Logo = styled.img`
  height: 130px;
  width: 130px;
`;
const SocialLinksSection = styled.div`
  @media screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media screen and (min-width: 768px) {
    float: right;
  }
`;
const CustomUl = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  @media screen and (max-width: 768px) {
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 16px;
    align-items: center;
  }
`;
const CustomLi = styled.li`
  margin: 10px 0px;
  font-size: 0.9rem;
  cursor: pointer;
`;
const CopyRightSection = styled.div`
  font-size: 14px;

  @media screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    // align-items: center;
    margin-bottom: 1rem;
    font-size: 16px;
    text-align: center;
  }
`;
const Hr = styled.hr`
  @media screen and (max-width: 768px) {
    /* margin-top: 4rem; */
  }
`;
const Link = styled(NavLink)`
  color: #fff;
`;

const DevelopedBySection = styled.div`
  margin-bottom: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  span {
    font-size: 14px;
    font-weight: normal;
    margin-right: 2px;
  }
  a {
    display: flex;
    flex-direction: row;
    align-items: center;
    img {
      height: 15px;
      padding: 0 8px 0 5px;
    }
    span {
      font-size: 14px;
      font-weight: normal;
      color: #ffffff;
      &:hover {
        color: #1196dd;
      }
    }
  }
`;

const FooterPublic3D: FC = () => {
  const user = JSON.parse(getUserData("user"));
  return (
    <>
      <FooterComp>
        <Row>
          <LogoCol
            lg={{ span: 6 }}
            md={{ span: 6 }}
            sm={{ span: 24 }}
            xs={{ span: 24 }}
          >
            <span>
              <Link to="/">
                <Logo src={Footerlogo} alt="" />
              </Link>
            </span>
          </LogoCol>
          <Col
            lg={{ span: 18 }}
            md={{ span: 18 }}
            sm={{ span: 24 }}
            xs={{ span: 24 }}
          >
            <Row>
              <Col
                lg={{ span: 8 }}
                md={{ span: 12 }}
                sm={{ span: 24 }}
                xs={{ span: 24 }}
              >
                <CustomUl>
                  <CustomLi>
                    <Link to="/">HOME</Link>
                  </CustomLi>
                  <CustomLi>
                    <Link to="/marketplace">MARKETPLACE</Link>
                  </CustomLi>
                  <CustomLi>
                    <Link to="/printers">PRINTERS</Link>
                  </CustomLi>
                  <CustomLi>
                    <Link to="/aboutus">ABOUT US</Link>
                  </CustomLi>
                  <CustomLi>
                    <Link to="/privacy">PRIVACY POLICY</Link>
                  </CustomLi>
                  {/* <CustomLi>CONTACT</CustomLi> */}
                </CustomUl>
              </Col>
              {/* <Col lg={{ span: 5 }} md={{ span: 12 }} xs={{ span: 24 }}>
                <CustomUl>
                  <CustomLi>3D PRINTER REVIEWS</CustomLi>
                  <CustomLi>TESTIMONALS</CustomLi>
                  <CustomLi>NEWS & BLOGS</CustomLi>
                  <CustomLi>CAREER</CustomLi>
                  <CustomLi>TERMS & CONDITI0NS</CustomLi>
                </CustomUl>
              </Col> */}
              <Col lg={{ span: 8 }} md={{ span: 12 }} xs={{ span: 24 }}>
                <CustomUl>
                  <CustomLi>CONTACT DETAILS</CustomLi>
                  <CustomLi style={{ display: "flex" }}>
                    <span
                      style={{
                        marginRight: "5px",
                      }}
                    >
                      <img src={locationIcon} alt="" />
                    </span>
                    <span>
                      LEVEL 1/622-632 Harris St, <br />
                      Ultimo NSW 2007
                    </span>
                  </CustomLi>
                  {/* <CustomLi>
                    <span
                      style={{
                        marginRight: "10px",
                        marginLeft: "10px",
                      }}
                    >
                      <img src={phoneIcon} alt="" />
                    </span>
                    <span>+61 416198587</span>
                  </CustomLi> */}
                  <CustomLi>
                    <span
                      style={{
                        marginRight: "5px",
                      }}
                    >
                      <img src={mailIcon} alt="" />
                    </span>
                    <span>help@3dprintit.net</span>
                  </CustomLi>
                </CustomUl>
              </Col>
              <Col lg={{ span: 8 }} md={{ span: 12 }} xs={{ span: 24 }}>
                <CustomUl>
                  {!user ? (
                    <CustomLi>
                      <Link to="/signin">LOGIN/SIGN UP</Link>
                    </CustomLi>
                  ) : (
                    <CustomLi onClick={userLogout}>LOGOUT</CustomLi>
                  )}
                  <CustomLi>SUBSCRIBE TO OUR NEWSLETTER</CustomLi>
                  <CustomLi>
                    <span className="mailchimp-form">
                      {/* <Search
                        style={{ marginTop: "5px" }}
                        placeholder="Enter Your Email"
                        enterButton="SUBSCRIBE"
                        size="large"
                      /> */}
                      <MailchimpSubscribe url={url} />
                    </span>
                    <span></span>
                  </CustomLi>
                </CustomUl>
              </Col>
            </Row>
            <Hr />
            <Row>
              <Col
                lg={{ span: 8 }}
                md={{ span: 8 }}
                sm={{ span: 24 }}
                xs={{ span: 24 }}
              >
                <CopyRightSection>
                  2022{" "}
                  <span>
                    <CopyrightOutlined />
                  </span>{" "}
                  Copyright | 3dprintit | All rights reserved
                </CopyRightSection>
              </Col>
              <Col
                lg={{ span: 8 }}
                md={{ span: 8 }}
                sm={{ span: 24 }}
                xs={{ span: 24 }}
              >
                <DevelopedBySection>
                  <span>Developed By: </span>
                  <a
                    href="https://cloud392.com.au"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="https://cloud392.com.au/wp-content/uploads/2021/10/white-cloud-icon.png"
                      alt="Cloud392"
                    />
                    <span>Cloud392</span>
                  </a>
                </DevelopedBySection>
              </Col>
              <Col
                lg={{ span: 8 }}
                md={{ span: 8 }}
                sm={{ span: 24 }}
                xs={{ span: 24 }}
              >
                <SocialLinksSection>
                  <span style={{ padding: "0px 5px" }}>
                    <LinkComponent
                      white
                      href={`https://www.facebook.com/3dprintit.net`}
                    >
                      <FacebookOutlined style={{ fontSize: "20px" }} />
                    </LinkComponent>
                  </span>
                  <span style={{ padding: "0px 5px" }}>
                    <LinkComponent
                      white
                      href={`https://twitter.com/3Dprintitnet`}
                    >
                      <TwitterOutlined style={{ fontSize: "20px" }} />
                    </LinkComponent>
                  </span>
                  <span style={{ padding: "0px 5px" }}>
                    <LinkComponent
                      white
                      href={`https://www.instagram.com/3dprintitnet/`}
                    >
                      <InstagramOutlined style={{ fontSize: "20px" }} />
                    </LinkComponent>
                  </span>
                  <span style={{ padding: "0px 5px" }}>
                    <LinkComponent
                      white
                      href={`https://www.linkedin.com/company/3dprintit/`}
                    >
                      <LinkedinOutlined style={{ fontSize: "20px" }} />
                    </LinkComponent>
                  </span>
                  <span style={{ padding: "0px 5px" }}>
                    {" "}
                    <LinkComponent
                      white
                      href={`https://www.youtube.com/channel/UC-ZSBDFE_7GepDRcX_is76Q`}
                    >
                      <YoutubeOutlined style={{ fontSize: "20px" }} />
                    </LinkComponent>
                  </span>
                </SocialLinksSection>
              </Col>
            </Row>
          </Col>
        </Row>
      </FooterComp>
    </>
  );
};

export default FooterPublic3D;
